import { createLivePreviewRequestHandler } from "src/utils/livePreviewHandler";

/**
 * Live preview request handler for `egd-carousel` (no drafts on this collection).
 */
export const egdCarouselLivePreviewRequestHandler = createLivePreviewRequestHandler(
  ({ serverURL, apiPath, docId }) =>
    `${serverURL}${apiPath}/egd-carousel/${docId}?depth=0`
);
